export default "__VITE_ASSET__GeMmR7iz__"